import Repository from './repository'

class ExportFile extends Repository {
  resource = 'download'

  async download(filename) {
    try {
      const file = await this.get({
        action: filename
      })

      return file
    } catch (_) {
      return null
    }
  }
}

export default ExportFile
